import { styled } from "@vitality-ds/system";
import BaseEmptyStateContainerStyles from "./styles/BaseEmptyStateContainer";

// eslint-disable-next-line import/prefer-default-export
export var BaseEmptyStateContainer = styled("div", BaseEmptyStateContainerStyles);